export default function (props: any) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 76 76" version="1.1" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g id="MM100-V1.2版本" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="MM100众筹详情-RV" transform="translate(-1110.000000, -5052.000000)">
                    <g id="编组-2" transform="translate(510.000000, 4798.000000)">
                        <g id="Fridge_icon" transform="translate(600.000000, 254.000000)">
                            <rect id="矩形" x="0" y="0" width="76" height="76"></rect>
                            <g id="编组-87备份-2" transform="translate(17.682432, 7.409756)" stroke="#000000" strokeWidth="2">
                                <g id="编组-26">
                                    <rect id="矩形" x="0" y="0" width="41.6351351" height="60.9365854" rx="5.70440154"></rect>
                                    <line
                                        x1="7.64173378"
                                        y1="7.8663796"
                                        x2="7.64173378"
                                        y2="13.2162219"
                                        id="Stroke-53"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                    ></line>
                                    <polyline
                                        id="Stroke-55"
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        points="7.64173378 31.411698 7.64173378 35.2085997 7.64173378 39.438988"
                                    ></polyline>
                                    <line x1="0.134165604" y1="24.3427457" x2="41.295284" y2="24.3427457" id="路径-5"></line>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
}
